import React, { useEffect } from "react";
import "../Tasks.css";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, Redirect } from "react-router-dom";
import { getSubOrdinates, getTaskCities, getTaskDoctors, getTaskPracticeLocations, } from "../../../actions/userActions/tasks/taskAction";
import { addTasks } from "../../../actions/userActions/tasks/taskAction";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Autocomplete from '@mui/material/Autocomplete';

import chevron_rightIcon from "../../../assets/images/chevron_rightIcon.svg";
import TextField from '@mui/material/TextField';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { getTaskTypes } from '../../../actions/userActions/tasks/taskAction';
import { getReportingEmployees } from '../../../actions/userActions/employeeAction';
import { getTaskProducts, getTaskSubTasks } from '../../../actions/userActions/tasks/taskAction';
import dayjs from 'dayjs';
import moment from "moment";
import { SaveButton } from "../../subComponents/buttons/SaveButton";
import HrComponent from "../../reuse_components/HrComponent";
import { getTaskPriorities } from "../../../actions/userActions/taskPriorityAction";
import { SIZE_OF_PAGE } from "../../../actions/types";
import { getSubTasks } from "../../../actions/userActions/subTaskAction";
import PrimaryButton from "../../subComponents/buttons/PrimaryButton";
import SingleSelect from "../../designSystem/SingleSelect";
import MultiSelect from "../../designSystem/MultiSelect";
import BodySmallMedium from "../../designSystem/BodySmallMedium";
import Heading6Regular from "../../designSystem/Heading6Regular";
import { getVisitProfileDetail } from "../../../actions/userActions/VisitProfileAction";
import { Typography } from "@mui/material";
import BodySmallRegular from "../../designSystem/BodySmallRegular";
import { Check } from "lucide-react";
import CancelButton from "../../subComponents/buttons/CustomCancelButton";
import BackNavHeader from "../../subComponents/BreadCrumbs/BackNavHeader ";
import { getTaskLookup } from "../../../actions/userActions/tasks/taskAction";
import AddNewDrawer from "../../addNew/AddNewDrawer";
import AddNewForm from "../../addNew/AddNewForm";
import cityicon from "../../../assets/images/cityIcon (2).svg";
import practicelocationicon from "../../../assets/images/practicelocationicon.svg";
import subtaskIcon from "../../../assets/images/subtaskIcon.svg";
import { getCities } from "../../../actions/userActions/cityAction";
import { getPracticeLocations } from "../../../actions/userActions/practiceLocationAction";
import { getProducts } from "../../../actions/userActions/productAction";
import { t } from "../../../locales/translate";
import LoadingOverlay from "../../loadingOverlay/LoadingOverlay";

function AddTasks(props) {
  const history = useHistory();
  const currentDate = moment();
  const location = useLocation();
  const dispatch = useDispatch();
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));
  const user = JSON.parse(localStorage.getItem("user"));
  const preselectedCity = user.result[0] !== undefined ? user.result[0].user.cityId : false;
  const [doctorCity, setDoctorCity] = useState(preselectedCity);
  const [locationCity, setLocationCity] = useState(preselectedCity);
  const [formErrors, setFormErrors] = useState({});
  const [isAssignedToMe, setIsAssignedToMe] = useState(false);
  const [assignedToName, setAssignedToName] = useState("");
  const addTask = useSelector((state) => state.tasks_reducer.addTask);
  const isAddTaskLoading = addTask === "isLoading";

  const employeeId = user.result[0] !== undefined ? user.result[0].user.id : false;
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerItem , setDrawerItem] = useState(null);
  const [isPracticeLocationsLoading, setIsPracticeLocationsLoading] = useState(false);
  const [drawerLoading, setDrawerLoading] = useState(false);
  const [isDoctorsLoading, setIsDoctorsLoading] = useState(false);

  const DRAWER_ICONS = {
    city: cityicon,
    practiceLocation: practicelocationicon,
    subTask: subtaskIcon,
      };
const darwerIcon = DRAWER_ICONS[drawerItem] ? <img src={DRAWER_ICONS[drawerItem]} alt={drawerItem} /> : null;
  const initialValues = {
    employeeId: "",
    title: "",
    description: "",
    doctorId: "",
    practiceLocationId: "",
    assignedTo: "",
    priority: "",
    type: 0,
    products: [],
    subTasks: [],
    visitDate: moment(currentDate).format("YYYY-MM-DD"),
    createdByName: "",
    accompaniedByIds: [],
    isPlanned: false
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [query, setQuery] = useState('');

  const [selectedValues, setSelectedValues] = useState(initialValues);
  const allProductBody = {
    "filter": {
      "textSearch": ""
    },
    "pageNumber": -1,
    "pageSize": 0
  }
  useEffect(() => {
    setFormValues({
      ...formValues,
      employeeId: user.result[0]?.user.id,
      createdByName: `${user.result[0]?.user.firstName} ${user.result[0]?.user.lastName}`,
    });
  }, []);

  useEffect(() => {
    const pageNumber = -1
    dispatch(getTaskLookup(employeeId)).then(() => {
    });
  }, []);

  useEffect(() => {
  if (locationCity) {
    setIsPracticeLocationsLoading(true);
    setIsDoctorsLoading(false);
    dispatch(getTaskPracticeLocations(locationCity)).finally(() => {
      setIsPracticeLocationsLoading(false);
    });
  }
}, [locationCity]);

  useEffect(() => {
  if (doctorCity) {
    setIsDoctorsLoading(true);
    const allDoctorsBody = {
      pageNumber: -1,
      pageSize: 0,
      textSearch: "",
      cityId: doctorCity,
    };
    dispatch(getTaskDoctors(allDoctorsBody)).finally(() => {
      setIsDoctorsLoading(false);
    });
  }
}, [doctorCity]);

  const doctors = useSelector(state => state.tasks_reducer.taskDoctors);
  const locations = useSelector(state => state.tasks_reducer.taskPracticeLocations);
 
  const taskLookups = useSelector((state) => state.taskLookupReducer.taskLookups);
  const subTasks = taskLookups.subTasks;
  const loading = useSelector((state) => state.taskLookupReducer.taskLookupLoading)
  
  const products = taskLookups.products;
  const employees = taskLookups.subOrdinates;
  const visitProfileData = useSelector(state => state.visitProfile_reducer.visitProfileDetail);
  const subTasksData = subTasks && subTasks.result;
  const reportingEmployee = taskLookups.reporting;
  const accompaniedByData = reportingEmployee && reportingEmployee.result
  
  const priorities = taskLookups.taskPriorities;
  const prioritiesData = priorities && priorities.result;
  
  const cities = taskLookups.cities;
  
  const handleDoctorCityChange = (event) => {
    setDoctorCity(event.target.value);
  };

  const handleDateChange = (date) => {
    if (!date) return;

    const formattedDate = dayjs(date).format('YYYY-MM-DD');
    setSelectedValues(prevValues => ({
      ...prevValues,
      visitDate: formattedDate,
    }));
    setFormValues(prevValues => ({
      ...prevValues,
      visitDate: formattedDate,
    }));
  };
  useEffect(() => {
    
    if (preselectedCity) {
      dispatch(getVisitProfileDetail({ cityId: preselectedCity }));

    }
  }, [dispatch, preselectedCity]);
  const handleLocationChange = (selectedPracticeLocationId) => {
  setIsDoctorsLoading(true);
  
  setSelectedValues({
    ...selectedValues,
    practiceLocationId: selectedPracticeLocationId,
    doctorId: null,
  });
  setFormValues(prevValues => ({
    ...prevValues,
    practiceLocationId: selectedPracticeLocationId,
  }));
    setTimeout(() => {
    setIsDoctorsLoading(false);
  }, 100);
};

  const handleDoctorChange = (selectedDoctorId) => {
    // Update selected doctor
    setSelectedValues({
      ...selectedValues,
      doctorId: selectedDoctorId,
    });

    setFormValues(prevValues => ({
      ...prevValues,
      doctorId: selectedDoctorId
    }));
  };

   const handleAddNew = (itemName) => {
  setDrawerItem(itemName);
      setDrawerOpen(true);
    };

  const handlePriorityChange = (selectedPriority) => {
    setFormValues(prevValues => ({
      ...prevValues,
      priority: selectedPriority.value, // assuming selectedPriority is an object with a value and label
    }));
    setSelectedValues({
      ...selectedValues,
      priority: selectedPriority.value,
    });
  };

  const handleAssignToChange = (selectedAssignToId) => {
    setSelectedValues(prevValues => ({
      ...prevValues,
      assignedTo: selectedAssignToId,
    }));
    setFormValues(prevValues => ({
      ...prevValues,
      assignedTo: selectedAssignToId,
    }));
  };
  const handleAccompaniedByChange = (updatedIds) => {
    setSelectedValues(prev => ({
      ...prev,
      accompaniedByIds: updatedIds, // [1, 2]
    }));

    setFormValues(prev => ({
      ...prev,
      accompaniedByIds: updatedIds,
    }));
  };

  const handleProductChange = (updatedValues) => {
    setSelectedValues(prevValues => ({
      ...prevValues,
      products: updatedValues,
    }));

    setFormValues(prevValues => ({
      ...prevValues,
      products: updatedValues,
    }));
  };

  const handleSubTasksChange = (updatedSubTasks) => {
    setSelectedValues(prevValues => ({
      ...prevValues,
      subTasks: updatedSubTasks,
    }));

    setFormValues(prevValues => ({
      ...prevValues,
      subTasks: updatedSubTasks,
    }));
  };


  const validate = (values) => {
  const errors = {};
  if (!values.doctorId) {
    errors.doctorId = "Doctor is required!";
  }
  if (!values.practiceLocationId) {
    errors.practiceLocationId = "Location is required!";
  }

  if (!values.assignedTo) {
    errors.assignedTo = "Assigned To is required!";
  }
  if (!values.priority) {
    errors.priority = "Priority is required!";
  }
  if (values.products.length === 0) {
    errors.products = "Products is required!";
  }
  if (values.subTasks.length === 0) {
    errors.subTasks = "Sub Tasks is required!";
  }
  if (!values.visitDate) {
    errors.visitDate = "Visit Date is required!";
  }


  return errors;
};
  const addTaskHandle = async (e) => {
    e.preventDefault();
    const updatedFormValues = {
      ...formValues,
      assignedTo: isAssignedToMe ? employeeId : formValues.assignedTo,
    };
    const errors = validate(updatedFormValues);
    if (Object.keys(errors).length === 0) {
      dispatch(addTasks(updatedFormValues));
    } else {
      setFormErrors(errors);
    }
  };

  const handleGoBack = () => {
    history.goBack();
  };
  const handleLocationCityChange = (selectedCityId) => {
    setLocationCity(selectedCityId.value);
    dispatch(getVisitProfileDetail({ cityId: selectedCityId.value }));

    // ✅ Also update form values when city is manually changed
    setFormValues(prev => ({
      ...prev,
      cityId: selectedCityId.value,
      // Reset location and doctor when city changes manually
      practiceLocationId: "",
      doctorId: "",
    }));

    setSelectedValues(prev => ({
      ...prev,
      cityId: selectedCityId.value,
      practiceLocationId: "",
      doctorId: "",
    }));
  };
  const handleChange = () => {
    if (!isAssignedToMe) {
      setAssignedToName("");
      setSelectedValues({ ...selectedValues, assignedTo: "" });
    } else {
      setAssignedToName(employeeId);
      setSelectedValues({ ...selectedValues, assignedTo: employeeId });
    }
    setIsAssignedToMe(!isAssignedToMe);
  };
  const getOptions = (type) => {
    if (type === "cities") {
      if (cities !== "isLoading" && cities.length !== 0 && cities?.[0]?.cities?.length !== 0) {
        return cities?.[0]?.cities
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((city) => ({
            value: city.id,
            label: city.name
          }));
      }
      return [];
    }

    if (type === "practiceLocations") {
  if (isPracticeLocationsLoading || visitProfileData === "isLoading") {
    return [{ value: 'loading', label: 'Loading...', isDisabled: true }];
  }

  if (visitProfileData && visitProfileData.result) {
    const locations = [];
    const addedIds = new Set();

    visitProfileData.result.forEach(profile => {
      profile.visitLocations.forEach(visitLoc => {
        const location = visitLoc.practiceLocation;
        if (!addedIds.has(location.id)) {
          addedIds.add(location.id);
          locations.push({
            value: location.id,
            label: location.name
          });
        }
      });
    });

    if (locations.length === 0) {
      return [{ value: 'no-data', label: 'No data', isDisabled: true }];
    }

    return locations.sort((a, b) => a.label.localeCompare(b.label));
  }
  return [{ value: 'no-data', label: 'No data', isDisabled: true }];
}

    if (type === "doctors") {
  if (isDoctorsLoading || visitProfileData === "isLoading") {
    return [{ value: 'loading', label: 'Loading...', isDisabled: true }];
  }

  if (visitProfileData && visitProfileData.result && selectedValues.practiceLocationId) {
    let doctors = [];
    visitProfileData.result.forEach(profile => {
      profile.visitLocations.forEach(visitLoc => {
        if (visitLoc.practiceLocation.id === selectedValues.practiceLocationId) {
          doctors = visitLoc.practiceLocation.doctors.map(doctor => ({
            value: doctor.id,
            label: doctor.name
          }));
        }
      });
    });

    if (doctors.length === 0) {
      return [{ value: 'no-data', label: 'No data', isDisabled: true }];
    }

    return doctors.sort((a, b) => a.label.localeCompare(b.label));
  }
  return [{ value: 'no-data', label: 'No data', isDisabled: true }];
}
    if (type === "assignedTo") {
      if (employees !== "isLoading" && employees.length !== 0) {
        return employees
          .sort((a, b) => a.firstName.localeCompare(b.firstName))
          .map(employee => ({
            value: employee.id,
            label: `${employee.firstName} ${employee.lastName}`,
          }));
      }
      return [];
    }

    if (type === "products") {
      if (products !== "isLoading" && products.length !== 0) {
        return products
          .filter((product) => product.active)
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((product) => ({
            value: product.id,
            label: product.name
          }));
      }
      return [];
    }

    // ✅ New Case for Sub Tasks
    if (type === "subTasks") {
      if (subTasks !== "isLoading" && Array.isArray(subTasksData) && subTasksData.length !== 0) {
        return subTasksData
          .filter((subTask) => subTask.active) // Only active sub tasks
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((subTask) => ({
            value: subTask.id,
            label: subTask.name
          }));
      }
      return [];
    }
    if (type === "accompaniedBy") {
      if (reportingEmployee !== "isLoading" && reportingEmployee.length !== 0) {
        return reportingEmployee
          .sort((a, b) => {
            const firstNameComparison = a.firstName.localeCompare(b.firstName);
            return firstNameComparison === 0
              ? a.lastName.localeCompare(b.lastName)
              : firstNameComparison;
          })
          .map((employee) => ({
            value: employee.id,
            label: `${employee.firstName} ${employee.lastName}`
          }));
      }
    }

    if (type === "priorities") {
      if (priorities !== "isLoading" && prioritiesData?.length !== 0) {
        return prioritiesData
          ?.filter(priority => priority.active)
          .sort((a, b) => a.name.localeCompare(b.name))
          ?.map((priority) => ({
            value: priority.id,
            label: priority.name
          }));
      }
    }
    return [];
  };
  return (
    <>
      {(addTask && addTask !== "isLoading") && <Redirect to="/admin/tasks" />}
      {!permissions.includes("CanAddTask") && <Redirect to="/admin" />}
      {!permissions.includes("CanUpdateTask") && <Redirect to="/admin" />}
      {!location.id && <Redirect to={"/admin/AddTasks"} />}
      <div className="add-doctor-container">
        <LoadingOverlay isVisible={loading || isAddTaskLoading} />
        <BackNavHeader text={t("addTask")} onBack={handleGoBack}/>
        <div className="add-content-wrapper">
          <div className="row">
            <div className="col-6" style={{ position: 'relative' }}>
              <div style={{ marginBottom: "6px" }}>
                <BodySmallMedium  text={`${t("visitDate")} *`} color="#1e293b" />
              </div>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  valueType="date"
                  minDate={dayjs()}
                  value={selectedValues.visitDate && selectedValues.visitDate.length !== 0 ? dayjs(selectedValues.visitDate) : null}
                  onChange={handleDateChange}
                   format="MMMM D, YYYY"
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      height: "40px",
                      padding: "0",
                      boxSizing: "border-box",
                      backgroundColor: "transparent",
                      border: "1px solid #E0E0E0",
                      borderRadius: "60px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      }, "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                    },
                    "& .MuiInputBase-input": {
                      height: "32px",
                      padding: "0px 8px",
                      fontSize: "14px",
                    },
                    "& .MuiIconButton-root": {
                      padding: "20px",
                    },
                  }}
                />
              </LocalizationProvider>
            </div>
            <div className="col-6">
              <SingleSelect
                    label= {`${t("city")} *`}
                    isSearchable
                    iconEnd
                    error={formErrors.city}
                    disabled={false}
                    onChange={handleLocationCityChange}
                    value={locationCity}
                    placeholder={t("city")}
                    options={
                      Array.isArray(cities) && cities.length > 0
                        ? cities.map((city) => ({
                            label: city.name,
                            value: city.id,
                          }))
                        : []
                    }
                    onAddNewClick={() => handleAddNew("city")}
                    configKey={"city"}
                  />
            </div>


          </div>
          <div className="row">
            <div className="col-6">
              <SingleSelect
                label= {`${t("practiceLocation")} *`}
                isSearchable
                secondaryLabel
                iconEnd
                value={selectedValues.practiceLocationId}
                onChange={(option) => handleLocationChange(option.value)}
                placeholder={t("practiceLocation")}
                options={getOptions("practiceLocations")}
                disabled={false} // Use the separate state
                configKey={"practiceLocation"}
                onAddNewClick={() => handleAddNew("practiceLocation")}
              />
            </div>

            <div className="col-6">
              <SingleSelect
                label= {`${t("doctor")} *`}
                value={selectedValues.doctorId}
                error={formErrors.doctorId}
                onChange={(option) => handleDoctorChange(option.value)}
                options={getOptions("doctors")}
                placeholder={t("doctor")}
                isSearchable
                disabled={false} // Use the separate state
              />
            </div>
          </div>
          <div className="row">
            <div className="col-6">
                  <MultiSelect
                    isSearchable
                    value={selectedValues.products} // Array of selected product IDs
                    onChange={handleProductChange}  // Updates the products values
                    label= {`${t("product")} *`}
                    options={
                      Array.isArray(products)
                        ? products.map((product) => ({
                            label: product.name,
                            value: product.id
                          }))
                        : []
                    }
                    onAddNewClick={() => handleAddNew("products")}
                  />

            </div>

            <div className="col-6">
              <MultiSelect
                  isSearchable
                  value={selectedValues.subTasks}
                  onChange={handleSubTasksChange}
                  label= {`${t("subTask")} *`}
                  options={
                    Array.isArray(subTasks) && subTasks.length > 0
                      ? subTasks.map((task) => ({
                          label: task.name,
                          value: task.id,
                        }))
                      : []
                  }
                  configKey={"subTask"}
                  onAddNewClick={() => handleAddNew("subTask")}
                />
            </div>
          </div>

          <div className="row">
            <div className="col-6">
               <SingleSelect
                label= {`${t("assignTo")} *`}
                isSearchable
                value={isAssignedToMe ? employeeId : selectedValues.assignedTo}
                onChange={(event) => {
                  if (!isAssignedToMe) {
                    handleAssignToChange(event.value);
                  }
                }}
                placeholder={t("employee")}
                options={
                  Array.isArray(taskLookups?.subOrdinates)
                    ? taskLookups.subOrdinates.map((employee) => ({
                        label: `${employee.firstName} ${employee.lastName}`,
                        value: employee.id
                      }))
                    : []
                }
              />
            </div>

            <div className="col-6">
              <SingleSelect
                label= {`${t("priority")} *`}
                isSearchable
                options={
                  Array.isArray(taskLookups?.taskPriorities)
                    ? taskLookups.taskPriorities.map((priority) => ({
                        label: priority.name,
                        value: priority.id
                      }))
                    : []
                }
                value={formValues.priority} // selected ID
                onChange={handlePriorityChange}
                placeholder={t("priority")}
                error={formErrors.priority}
              />
            </div>

            <div className="form-group" style={{ display: "flex", alignItems: "flex-start" }}>
              <input
                name="active"
                style={{ cursor: "pointer", height: "16px", width: "16px" }}
                type="checkbox"
                checked={isAssignedToMe}
                className="ml-1 mt-1"
                onChange={handleChange}
              />

              <label
                style={{ paddingLeft: "10px", }}
                className="form-control-label"

              >
                 {`${t("assignToMe")} *`}
              </label>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
               <MultiSelect
              isSearchable
              onChange={handleAccompaniedByChange}
                value={selectedValues.accompaniedByIds} // [1, 2]
              label= {`${t("accompaniedBy")} *`}
              options={
                Array.isArray(taskLookups?.reporting)
                  ? taskLookups.reporting.map((emp) => ({
                      label: `${emp.firstName} ${emp.lastName} (${emp.designationName})`,
                      value: emp.id
                    }))
                  : []
              }
            />
            </div>
          </div>

          <div className="add-doctor-form-actions">  
          <CancelButton onClick={handleGoBack} text={t("cancel")} width={document.body.dir === "rtl" ? "119px" : ""}/>
            <PrimaryButton
              onClick={addTaskHandle}
              text={t("save")}
              icon={Check}
            />
          </div>
        </div>
      </div>
      <AddNewDrawer
  open={drawerOpen}
  onClose={() => setDrawerOpen(false)}
  title={drawerItem? t("addItem").replace(/{{item}}/g, t(drawerItem)): ""}
  subtext={drawerItem ? t("createNewItemRecord").replace(/{{item}}/g, t(drawerItem)) : ""}
  icon={darwerIcon}
  loading={drawerLoading}
>
  {drawerItem && (
    <AddNewForm
  itemName={drawerItem}
  onClose={() => setDrawerOpen(false)}
  onLoadingChange={setDrawerLoading}
  onSave={(newData) => {
  }}
/>
  )}
</AddNewDrawer>

    </>
  );
}

export default AddTasks;
